import store from '../store/index'

//------------
// spell call
//------------
export default async function useSpellCall(apiParms) {
  const response = await store.dispatch('spells/editSpell', apiParms)
  return response.data
}
